import React from "react";
import { Link } from "react-router-dom";
import landingPageData from "../data/landingPageData.json";
import { TheNavbar } from "./Navbar";
import { TheFooterFunction } from "./Footer";

export function LandingPage() {
  const { header, mainDescription, features } = landingPageData;

  const featuresContent = features.map((feature, index) => (
    <Feature key={index} feature={feature} />
  ));

  return (
    <div>
      <TheNavbar />
      <LandingHeader header={header} />
      <MainDescription mainDescription={mainDescription} />
      <FeaturesSection featuresContent={featuresContent} /> 
      <TheFooterFunction />
    </div>
  );
}

function LandingHeader({ header }) { 
  const { highlight, text } = header;
  return (
    <header className="landing-page-header">
      <div className="container text-layout">
        <p>
          Choosing the right college major can be overwhelming, but <span className="color-bold">{highlight}</span> {text}
        </p>
      </div>
    </header>
  );
}

function MainDescription({ mainDescription }) { 
  const { title, description } = mainDescription;
  return (
    <main className="landing-main-content">
      <div className="container-item text-layout">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    </main>
  );
}

function FeaturesSection({ featuresContent }) {
  return (
    <section className="features">
      <h1>What’s next?</h1>
      <div className="features-container">
        {featuresContent} 
      </div>
    </section>
  );
}

function Feature({ feature }) { 
  const { link, imgSrc, altText, text } = feature;
  return (
    <div className="feature-button">
      <Link to={link}>
        <img src={imgSrc} alt={altText} />
        <h2>{text}</h2>
      </Link>
    </div>
  );
}

export default LandingPage;
